
import { Component, Prop } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';
import Product from '@/store/entities/baseInfo/Product';
import SelectAuthMode from './product-list-select-auth-mode.vue';
import ProductListCore from './product-list-core.vue';

@Component({
  components: {
    SelectAuthMode,
    ProductListCore
  }
})
export default class ProductList extends AbpBase {
  @Prop({ type: Array, default: new Array<Product>() }) products: Array<Product>;
  @Prop({ type: Number, default: 4 }) columnCount: number;

  columnWidth: string = "23.26%";
  selectAuthModeModalShow: boolean = false;
  selectedProduct: Product = new Product();

  created() {
    switch (this.columnCount) {
      case 1:
        this.columnWidth = '100%';
        break;
      case 2:
        this.columnWidth = '45%';
        break;
    }
  }
}
